import type {
  ActionWithPayload,
  ActionWithRequiredPayload,
} from '@/domains/core/applicationState/interfaces';
import type { HydrateAction } from '@/domains/core/applicationState/store/hydrateAction';
import type { SpartacuxProductDiscoveryDomainState } from '@/domains/productDiscovery/productDiscovery.model';
import { GraphqlSuccess } from '@/productDiscovery/ProductPage/detail.actions';

import type { BulkPurchaseData } from '../interfaces/BulkPurchase.model';

export const GET_BULK_PURCHASE = 'product/GET_BULK_PURCHASE';
export const GET_BULK_PURCHASE_SUCCESS = 'product/GET_BULK_PURCHASE_SUCCESS';
export const GET_BULK_PURCHASE_FAILURE = 'product/GET_BULK_PURCHASE_FAILURE';

export type GetBulkPurchaseSuccessAction = ActionWithRequiredPayload<
  { data: BulkPurchaseData[] },
  typeof GET_BULK_PURCHASE_SUCCESS
>;

export const getBulkPurchaseSuccess = (
  data: BulkPurchaseData[],
): GetBulkPurchaseSuccessAction => ({
  type: GET_BULK_PURCHASE_SUCCESS,
  payload: { data },
});

export type GetBulkPurchaseFailureAction = ActionWithPayload<
  { error: string },
  typeof GET_BULK_PURCHASE_FAILURE
>;

export const getBulkPurchaseFailure = (
  error: string,
): GetBulkPurchaseFailureAction => ({
  type: GET_BULK_PURCHASE_FAILURE,
  payload: { error },
});

export type BulkPurchaseAction =
  | HydrateAction<SpartacuxProductDiscoveryDomainState>
  | GraphqlSuccess
  | GetBulkPurchaseSuccessAction
  | GetBulkPurchaseFailureAction;
